module.exports = __webpack_public_path__ + "img/sann.d98044c7.png";